import axios from '@/helpers/axios'

export default {
  /**
   * 获取角色列表
   *
   * @param {object} query 查询
   * @param {string} query.keyword 关键字查询
   * @param {string} query.created_at 时间范围查询
   * @param {string} query.service_provider_id 运营商查询
   * @returns {Promise<object>} 格式 { roles: [] }
   */
  getRoles(query) {
    return axios.get('/backend/roles', { query: query })
  },

  /**
   * 返回指定的角色信息
   *
   * @param {string} id 编号
   * @returns {Promise<object>} 角色详情
   */
  getRole(id) {
    return axios.get(`/backend/roles/${id}`)
  }
}
